/*
 * @file Exports a function that reports per-device hardware support facts.
 *
 * PRO-33773: distinct from `bits/app_can.ts`'s Capabilities system, which only models
 * group-based feature rollout (`WW-Capabilities`). This reads a standalone
 * `WW-Device-Supported` header (e.g. VisionKit/Play Services availability) that mobile
 * reports regardless of rollout group.
 */

function getDeviceSupportedFeatures(): string[] {
  const wwAttribute = document.body.getAttribute('ww-device-supported')
  if (wwAttribute == null || wwAttribute === '') return []
  return wwAttribute.split(',')
}

type DeviceSupportedFeature = 'documentScanner'

function isDeviceSupportedFor(feature: DeviceSupportedFeature): boolean {
  const features = getDeviceSupportedFeatures()
  return features.includes(feature)
}
export { isDeviceSupportedFor }
